import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'blockId'
})
export class BlockIdPipe implements PipeTransform {
    transform(name: string | undefined, blockId: string, devMode: boolean): string | undefined {
        if (!name || !devMode) {
            return name;
        }
        return `${name} (${blockId})`;
    }
}
